import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Responsive from 'react-responsive';
import classNames from 'classnames';

import TooltipModal from './TooltipModal';

import styles from './index.scss';

export const TOOLTIP_DIRECTION_NORTH = 'north';
export const TOOLTIP_DIRECTION_SOUTH = 'south';
export const TOOLTIP_DIRECTION_WEST = 'west';
export const TOOLTIP_DIRECTION_EAST = 'east';

const Desktop = props => <Responsive {...props} minWidth={961} />;
const Mobile = props => <Responsive {...props} maxWidth={960} />;

class Tooltip extends Component {
    state = {
        isOpen: false,
        showTooltip: false,
    };
    timerId = null;

    componentWillUnmount() {
        clearTimeout(this.timerId);
    }

    toggleModal = ev => {
        this.setState({
            isOpen: !this.state.isOpen,
        });

        ev && ev.preventDefault && ev.preventDefault();
    };

    disableSelectionChoosing = ev => {
        ev && ev.preventDefault && ev.preventDefault();
    };

    handleMouseEnter = ev => {
        ev && ev.preventDefault && ev.preventDefault();
        clearTimeout(this.timerId);
        this.setState({ showTooltip: true });
    };

    handleMouseLeave = ev => {
        ev && ev.preventDefault && ev.preventDefault();
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            this.setState({
                showTooltip: false,
            });
        }, this.props.delayTime);
    };

    handleMouseEnterOnContent = ev => {
        ev && ev.preventDefault && ev.preventDefault();
        clearTimeout(this.timerId);
    };

    render() {
        const { direction, tooltipText } = this.props;
        const tooltipContentClass = classNames({
            [styles.tooltipContent]: true,
            [styles.tooltipContentDirectionNorth]: direction === TOOLTIP_DIRECTION_NORTH,
            [styles.tooltipContentDirectionSouth]: direction === TOOLTIP_DIRECTION_SOUTH,
            [styles.tooltipContentDirectionWest]: direction === TOOLTIP_DIRECTION_WEST,
            [styles.tooltipContentDirectionEast]: direction === TOOLTIP_DIRECTION_EAST,
        });
        return (
            <div className={`${styles.tooltipWrapper} custom-list ${this.props.extraClass}`}>
                <Desktop>
                    <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                        <i
                            className={styles.tooltipIcon}
                            alt="tooltip"
                            onClick={this.disableSelectionChoosing}
                            onKeyPress={() => {}}
                        />
                        {this.state.showTooltip ? (
                            <div
                                className={tooltipContentClass}
                                onMouseEnter={this.handleMouseEnterOnContent}
                                onMouseLeave={this.handleMouseLeave}
                            >
                                <p className={styles.tooltipImageBlock}>
                                    <img src={this.props.tooltipImagePath} alt="" />
                                </p>
                                <div>
                                    <FormattedMessage id={tooltipText}>
                                        {(txt) => <span dangerouslySetInnerHTML={{ __html: txt }} />}
                                    </FormattedMessage>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </Desktop>
                <Mobile>
                    <button className={styles.iconButton} onClick={this.toggleModal} />
                    {this.state.isOpen ? (
                        <TooltipModal onClose={this.toggleModal}>
                            <p className={styles.tooltipImageBlock}>
                                <img src={this.props.tooltipImagePath} alt="" />
                            </p>
                            <div>
                                <FormattedMessage id={tooltipText}>
                                    {(txt) => <span dangerouslySetInnerHTML={{ __html: txt }} />}
                                </FormattedMessage>
                            </div>
                        </TooltipModal>
                    ) : null}
                </Mobile>
            </div>
        );
    }
}
Tooltip.propTypes = {
    delayTime: PropTypes.number.isRequired,
    tooltipText: PropTypes.string.isRequired,
    tooltipImagePath: PropTypes.string.isRequired,
    tooltipMobileHeader: PropTypes.string,
    values: PropTypes.any,
    extraClass: PropTypes.string,
    direction: PropTypes.oneOf([
        TOOLTIP_DIRECTION_NORTH,
        TOOLTIP_DIRECTION_SOUTH,
        TOOLTIP_DIRECTION_WEST,
        TOOLTIP_DIRECTION_EAST,
    ]),
};

Tooltip.defaultProps = {
    values: {},
    extraClass: '',
    direction: TOOLTIP_DIRECTION_NORTH,
};

export default Tooltip;
